// src/components/PromiseAnimation.js
import React from 'react';

const PromiseAnimation = () => {
  // The original component was removed due to dependency issues with @react-three/fiber and @react-three/drei.
  // This is a simple placeholder to avoid breaking the application.
  return (
    <div style={{ 
      height: '200px', 
      width: '100%', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      backgroundColor: '#1a1a1a',
      color: 'gold',
      fontFamily: 'sans-serif',
      fontSize: '1.75rem',
      textAlign: 'center',
      transform: 'rotate(-2.8deg)',
      border: '1px solid gold',
      borderRadius: '8px'
    }}>
      The Future is Bright
      <br />
      If u support Arsenal
    </div>
  );
};

export default PromiseAnimation;